import { injectIntl } from "react-intl";
import { FormGroup, Input, Label } from "reactstrap";

const FixtureSearch = (props) => {
  const { doSearch, intl, initial } = props;
  const { formatMessage } = intl;

  return (
    <FormGroup className="fixture-search">
      <Label for="search">
        <i className="fas fa-search" />
      </Label>
      <Input
        type="search"
        name="search"
        id="search"
        value={initial}
        placeholder={formatMessage({
          id: "search",
          defaultMessage: "search",
        })}
        onChange={(e) => doSearch(e.target.value)}
      />
    </FormGroup>
  );
};

export default injectIntl(FixtureSearch);
